module.exports = __webpack_public_path__ + "e8536bb2086369d70fe46115808ca685.svg";